import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={28} height={43} fill="none" {...props}>
        <Path
            fill={designSystem.colors.neutral900}
            stroke={designSystem.colors.neutral400}
            d="M12.18.5c7.667 0 13.622 4.55 13.622 10.922 0 3.393-1.68 6.66-4.31 8.473 3.064 1.619 5.444 4.926 5.444 9.131C26.936 36.211 20.827 42 12.072 42 6.947 42 2.86 40.237.636 37.844l-.135-.145.001-.198.054-10.044.01-1.765.918 1.508c2.175 3.573 6.169 5.592 9.724 5.592 1.73 0 3.112-.44 4.05-1.16.925-.71 1.444-1.712 1.444-2.93 0-1.268-.528-2.274-1.558-2.983-1.054-.725-2.669-1.161-4.854-1.161H7.684v-7.534h2.39c1.827 0 3.314-.393 4.328-1.064.996-.66 1.545-1.591 1.545-2.756 0-1.054-.45-1.919-1.278-2.535-.841-.627-2.103-1.015-3.731-1.015-4.024 0-7.017 2.005-8.994 4.659l-.874 1.172-.028-1.462-.162-8.64-.003-.156.087-.13C1.904 3.688 3.541 2.543 5.5 1.75 7.465.956 9.797.5 12.18.5Z"
        />
    </Svg>
);
export { SvgComponent as ThreeIcon };
